<template>
  <div>
    <v-row>
      <v-btn
        :disabled="this.measureGenerationRequest != ''"
        small
        v-on:click="generateMeasurementsRequest()"
        color="primary"
        dark
        >Generate Measurement Request</v-btn
      >
    </v-row>
    <v-row v-if="measureGenerationRequest !== ''">
      Measurement type :
      {{ measureGenerationRequest[0].requestedMeasurementType }}
    </v-row>
    <v-row v-if="measureGenerationRequest !== ''">
      Measurement step :
      {{ measureGenerationRequest[0].measurementsStep }}
    </v-row>
    <v-row
      v-if="
        measureGenerationRequest !== '' &&
        measureGenerationRequest[0].groundStation
      "
    >
      Measurement Ground Station :
      {{ measureGenerationRequest[0].groundStation.name }}
      (latitude: {{ measureGenerationRequest[0].groundStation.latitude }},
      longitude: {{ measureGenerationRequest[0].groundStation.longitude }})
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'exo-measurement-generation-request',

  props: { measureGenerationRequestFunction: Function },

  data() {
    return {
      measureGenerationRequest: ''
    }
  },

  mounted() {},

  computed: {},

  watch: {},

  methods: {
    async generateMeasurementsRequest() {
      let data = await this.$http
        .post('/physics/generateMeasurementsRequest')
        .then(function (response) {
          return response.data
        })
        .catch((e, __) => {
          this.errorTrace = this.getErrorMessage(e)
          return null
        })
      this.measureGenerationRequestFunction(data)
      this.measureGenerationRequest = data
      return data
    }
  }
}
</script>
